<h3 *ngIf="title!=''" [ngClass]="{'closed': hidden}"><span (click)="hidden = !hidden">{{title}}</span></h3>
<ol [hidden]="hidden">
    <li *ngFor="let element of elements; let i = index" ><span (click)="onSelect(i)">{{element}}</span></li>
</ol>
